import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import DashboardLayer from "../components/DashboardLayer";
import { Link } from "react-router-dom";

const getLocalUserName = () => {
    try {
        return JSON.parse(localStorage.getItem("user") || "{}")?.name || "there";
    } catch {
        return "there";
    }
};

const Dashboard = () => {
    const [meta, setMeta] = useState({ userName: getLocalUserName() });

    return (
        <MasterLayout>
            <div className="dash-welcome d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
                <div>
                    <h5>Welcome back, {meta.userName || getLocalUserName()}!</h5>
                    <p>
                        Here’s what’s happening with your WhatsApp messaging service today.
                        {meta.planName ? ` · Plan: ${meta.planName}` : ""}
                    </p>
                </div>
                <Link to="/instances" className="btn btn-success">
                    Sessions
                </Link>
            </div>

            <DashboardLayer onMeta={setMeta} />
        </MasterLayout>
    );
};

export default Dashboard;
